import { Component, HostListener, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from "@angular/material/dialog";
import { MatCheckboxChange } from '@angular/material/checkbox';

import { StructureFieldConfig, ConfigureStructureFields, IFieldRoleNamesChanged } from '../../models/structure/configure-structure-fields.model';
import { CurrentSiteService } from '../../services/current-site.service';
import { Role } from '../../models/role.model';

@Component({
    selector: 'app-configure-structure-fields',
    templateUrl: './configure-structure-fields.dialog.html',
    styleUrls: ['./configure-structure-fields.dialog.scss'],
    standalone: false
})
export class ConfigureStructureFieldsDialog implements OnInit, IFieldRoleNamesChanged {
    // Properties.
    //private hasIconsistentConfig: boolean = false;
    private configErrorMessage: string = null; // A non-null value for this property indicates that a configuration error has been detected.

    // Constructor.
    public constructor(@Inject(MAT_DIALOG_DATA) private data,
        private dialogRef: MatDialogRef<ConfigureStructureFieldsDialog>,
        private currentSiteService: CurrentSiteService)
    {
        return;
    }

    // Life cycle methods.
    public ngOnInit(): void {
        let configureStructureFields: ConfigureStructureFields = <ConfigureStructureFields>this.data;
        configureStructureFields.setFieldConfigRoleChangedHandler(this);
    }

    // Define accessor methods called by my HTML code.
    public get FieldConfigurations(): StructureFieldConfig[] {
        let configureStructureFields: ConfigureStructureFields = <ConfigureStructureFields>this.data;
        return configureStructureFields.FieldConfigs;
    }

    public get SiteRoleNames(): string[] {
        let roleNames: string[] = [];

        if (this.currentSiteService.Site.roles != null) {
            for (let index: number = 0; index < this.currentSiteService.Site.roles.length; index++) {
                let role: Role = this.currentSiteService.Site.roles[index];
                roleNames.push(role.name);
            }
        }

        return roleNames;
    }
    public get SiteRoles(): Role[] {
        return this.currentSiteService.Site.roles;
    }

    public get ConfigErrorMessage(): string {
        return this.configErrorMessage;
    }

    public get SaveButtonDisabled(): boolean {
        /*
        let configureStructureFields: ConfigureStructureFields = <ConfigureStructureFields>this.data;
        return configureStructureFields.HasInconsistentConfig;
        */
        //return this.hasIconsistentConfig;
        return this.configErrorMessage != null;
    }
    // End accessor methods.

    // Handle control events.
    public hideFieldChangedFor(fieldConfig: StructureFieldConfig, eventData: MatCheckboxChange): void {
        fieldConfig.disableForSpecifiedRoles = eventData.checked;

        this.computeConfigErrorMessage();
    }
    /*
    public roleNamesChangedFor(fieldConfig: StructureFieldConfig, eventData: any): void {
        this.computeConfigErrorMessage();
    }
    */
    public roleNamesChangedFor(fieldConfig: StructureFieldConfig): void {
        this.computeConfigErrorMessage();
    }

    public saveClicked(): void {
        let configureStructureFields: ConfigureStructureFields = <ConfigureStructureFields>this.data;
        configureStructureFields.setFieldConfigRoleChangedHandler(null);

        this.dialogRef.close(configureStructureFields);
    }

    public cancelClicked(): void {
        this.dialogRef.close(null);
    }

    // Helper methods.
    private computeConfigErrorMessage(): void {
        let configureStructureFields: ConfigureStructureFields = <ConfigureStructureFields>this.data;
        this.configErrorMessage = configureStructureFields.ConfigInconsistencyError;
    }
}
